// removed by extract-text-webpack-plugin
module.exports = {"container":"_2EU3hArz_9wnQnH9","tooltip":"_1Ia6Xo50NHhVbcbP","tooltip_item":"_3Lke-44h5gekvlMb"};


//////////////////
// WEBPACK FOOTER
// ./src/bundles/honest_work/components/WorkHonestlyTooltip/index.css
// module id = 421
// module chunks = 1